var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.274,20.995 C12.274,20.995 12.274,19.306 12.274,19.306 C12.274,16.523 10.438,14.153 7.883,13.258 C9.264,12.496 10.200,11.059 10.200,9.411 C10.200,9.048 10.149,8.696 10.064,8.358 C10.765,8.055 11.539,7.883 12.357,7.883 C12.357,7.883 12.357,7.883 12.357,7.883 C15.473,7.883 17.999,10.332 17.999,13.353 C17.999,13.353 17.999,20.995 17.999,20.995 C17.999,20.995 12.274,20.995 12.274,20.995 ZM12.357,6.917 C10.386,6.917 8.789,5.369 8.789,3.458 C8.789,1.548 10.386,-0.001 12.357,-0.001 C14.327,-0.001 15.924,1.548 15.924,3.458 C15.924,5.369 14.327,6.917 12.357,6.917 ZM5.636,12.870 C3.666,12.870 2.069,11.321 2.069,9.411 C2.069,7.501 3.666,5.952 5.636,5.952 C7.607,5.952 9.204,7.501 9.204,9.411 C9.204,11.321 7.607,12.870 5.636,12.870 ZM5.636,13.835 C8.752,13.835 11.278,16.284 11.278,19.306 C11.278,19.306 11.278,20.995 11.278,20.995 C11.278,20.995 -0.006,20.995 -0.006,20.995 C-0.006,20.995 -0.006,19.306 -0.006,19.306 C-0.006,16.284 2.520,13.835 5.636,13.835 C5.636,13.835 5.636,13.835 5.636,13.835 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollective);
export default ForwardRef;